<template>
  <div class="board__list-empty pa-5 grey lighten-5 text-center">
    <span class="grey--text">
      {{ $t('emptyState.noData') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'BoardLineEmpty',
}
</script>
